import React, { useState, useEffect, useRef } from "react";
import Progress from "../Progress/index";
import Text from "../Text/Text";
import styles from "./ScoreRanks.module.scss";
import Icon from "../../assets/icons/Icon";

function ScoreCharts(props) {
  const { scores } = props;
  return (
    <Container>
      {scores
        .sort((a, b) => a.order - b.order)
        .map((s) => (
          <ScoreBar
            key={s.label}
            label={s.label}
            color={s.color}
            progress={(s.score / 8) * 100}
            timeout={s.timeout}
          />
        ))}
      <Disclaimer />
    </Container>
  );
}

/** Contains the charts */
function Container({ children }) {
  return <div className={styles.container}>{children}</div>;
}

function ScoreBar(props) {
  const { label, progress, color, timeout } = props;
  const progressRef = useRef(progress);
  const [newProgress, setNewProgress] = useState(0);
  /** On mount, set the progress with the state and with pre-defined timeout.
   * This helps get around the fact that there's no animation due to it mounting because it now starts from 0 rather than the progress. */
  useEffect(() => {
    const t = setTimeout(() => {
      if (progressRef.current !== progress) return;
      setNewProgress(progress);
    }, timeout);

    return () => clearTimeout(t);
  }, [newProgress, progress, timeout]);
  return (
    <div className={styles.bar_group}>
      <Text variant="bodyRegular" className={styles.bar_label}>
        {label}
      </Text>
      <Progress progress={newProgress} color={color} />
    </div>
  );
}

function Disclaimer() {
  return (
    <div className={styles.disclaimer_wrapper}>
      <Icon icon="GtWarning" className={styles.disclaimer_icon} />
      <Text className={styles.disclaimer} variant="caption">
        Please note that this is only a sample of your digital score. To get a
        full overview of your digital maturity, get in touch with us today.
      </Text>
    </div>
  );
}

export default ScoreCharts;
